import { useMutation } from "@tanstack/react-query";

import client from "./client.ts";

import { useLanguageStore } from "@/store/languageStore.ts";
import type { Step1CompletedToken, VerificationChallenge } from "@/store/registrationStore.ts";

export interface RequestVerificationCodePayload {
	email: string;
	firstName: string | undefined;
	lastName: string | undefined;
}

export interface RequestVerificationCodeResponse {
	challenge: VerificationChallenge;
	codeExpirySeconds: number;
}

export interface VerifyCodePayload {
	email: string;
	code: string;
	challenge: VerificationChallenge;
}

export interface VerifyCodeResponse {
	step1CompletedToken: Step1CompletedToken;
}

export const useRequestVerificationCodeMutation = () => {
	const { lang } = useLanguageStore();

	return useMutation({
		mutationFn: (payload: RequestVerificationCodePayload) =>
			client
				.post<RequestVerificationCodeResponse>(`/email-verification/request-code?lang=${lang}`, payload)
				.then((res) => res.data)
	});
};

export const useVerifyAndRequestNewCodeMutation = () => {
	return useMutation({
		mutationFn: (payload: VerifyCodePayload) =>
			client
				.post<VerifyCodeResponse>("/email-verification/verify-and-request-new-code", payload)
				.then((res) => res.data)
	});
};
